
import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
import Axios from 'axios';
import Swal from "sweetalert2";
import { API_BASE_URL, INSERT_COMBO_PRODUCT, GET_COMBO_DDL } from '../../../Config';
import Select from 'react-select';

const AddComboProduct = () => {

    const [userDataSession, setUserDataSession] = useState([]);
    const [comboProductsDDL, setComboProductsDDL] = useState([]);
    const [childProductsDDL, setChildProductsDDL] = useState([]);

    const [selectedComboProduct, setSelectedComboProduct] = useState(null);
    const [selectedChildProducts, setSelectedChildProducts] = useState([]);
    const [childProductQuantities, setChildProductQuantities] = useState({});

    useEffect(() => {
        const userDataString = sessionStorage.getItem("userData");
        if (userDataString) {
            const userData = JSON.parse(userDataString);
            setUserDataSession(userData);

        } else {
            console.log("User data not found in sessionStorage");
        }
    }, []);

    useEffect(() => {
        if (userDataSession && userDataSession.OrgId) {

            Axios.get(`${API_BASE_URL}${GET_COMBO_DDL}?OrgId=${userDataSession.OrgId}&IsCompositeItem=1`)
                .then(response => {
                    if (response.data.Status) {
                        setComboProductsDDL(response.data.ResultData);
                    } else {
                        console.error('Error fetching data:', response.data);
                    }
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                });
            Axios.get(`${API_BASE_URL}${GET_COMBO_DDL}?OrgId=${userDataSession.OrgId}&IsCompositeItem=0`)
                .then(response => {
                    if (response.data.Status) {
                        setChildProductsDDL(response.data.ResultData);
                    } else {
                        console.error('Error fetching data:', response.data);
                    }
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                });
        }
    }, [userDataSession]);

    const [submitBtnLoading, setSubmitBtnLoading] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setSubmitBtnLoading(true);
    
        const payload = {
            OrgId: userDataSession.OrgId,
            CreatedBy: userDataSession.UserId,
            ProductComposites: selectedChildProducts.map((child) => ({
                MainProductId: selectedComboProduct.value,
                ChildProductId: child.value,
                Quantity: childProductQuantities[child.value] || 0,
            })),
        };
        console.log(payload, 'data sending to api');
    
        try {
            const response = await Axios.post(`${API_BASE_URL}${INSERT_COMBO_PRODUCT}`, payload);
            if (response.data[0]['Success'] == 1) {
                setSubmitBtnLoading(false);
                Swal.fire({
                    title: `Combo added Successfully.`,
                    icon: "success",
                }).then((result) => {
                    if (result.isConfirmed || result.isDismissed) {
                        window.location.reload();
                    }
                });
            } else {
                setSubmitBtnLoading(false);
                Swal.fire({
                    title: "Error",
                    text: "Failed to Request Submit.",
                    icon: "error",
                });
            }
            console.log('Combo added successfully:', response.data);
        } catch (error) {
            setSubmitBtnLoading(false);
            console.error('Error adding Combo:', error);
            Swal.fire({
                title: "Error",
                text: "Failed to Request Submit.",
                icon: "error",
            });
        }
    };    
    
    const handleQuantityChange = (childProductId, value) => {
        setChildProductQuantities({
          ...childProductQuantities,
          [childProductId]: value,
        });
    };

    const handleCancelBtnClick = () => {
        setSelectedComboProduct([]);
        setSelectedChildProducts([]);
    };

    return (
        <div>
            {/* Add Combo Product */}
            <div
                className="offcanvas offcanvas-end"
                tabIndex={-1}
                id="offcanvasRightAddComboProd"
                aria-labelledby="offcanvasRightLabel"
                style={{ minWidth: "30%", maxWidth: '40%' }}
            >
                <div className="offcanvas-header">
                    <h4 id="offcanvasRightLabel">Add Combo Producut</h4>
                    <button
                        type="button"
                        className="btn-close text-reset"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                    />
                </div>{" "}
                <hr />
                <div className="offcanvas-body">
                    <form onSubmit={handleSubmit}>
                        <div className="col-12">
                            <div className="input-blocks">
                                <label>Combo Product<span className="fw-bold text-danger">*</span></label>
                                <Select
                                    className="select"
                                    options={comboProductsDDL.map((prod) => ({
                                        value: prod.ProductId,
                                        label: prod.ProductName,
                                    }))}
                                    onChange={setSelectedComboProduct}
                                />
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="input-blocks">
                                <label>Child Products<span className="fw-bold text-danger">*</span></label>
                                <Select
                                    isMulti
                                    className="select"
                                    options={childProductsDDL.map((prod) => ({
                                        value: prod.ProductId,
                                        label: prod.ProductName,
                                    }))}
                                    onChange={setSelectedChildProducts}
                                />
                            </div>
                        </div>
                        <div className="col-12">
                            <table className="table datanew">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Product</th>
                                        <th>Quantity</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {selectedChildProducts.map((child, index) => (
                                        <tr key={child.value}>
                                        <td>{index + 1}</td>
                                        <td>{child.label}</td>
                                        <td>
                                            <input
                                            type="number"
                                            className="form-control"
                                            placeholder="Enter quantity"
                                            value={childProductQuantities[child.value] || ''}
                                            onChange={(e) =>
                                                handleQuantityChange(child.value, parseFloat(e.target.value))
                                            }
                                            />
                                        </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="modal-footer-btn">
                            <button
                                type="button"
                                className="btn btn-cancel me-2"
                                data-bs-dismiss="modal"
                                onClick={handleCancelBtnClick}
                                 disabled={submitBtnLoading}
                            >
                                Cancel
                            </button>
                            <button type="submit" className="btn btn-submit"
                             disabled={submitBtnLoading}>
                                {submitBtnLoading ? 'Submitting..' : 'Create'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
                    
    )
}

export default AddComboProduct
